var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-flag.94cf0818.png","uri@2x": __webpack_public_path__ + "icon-flag.6787d10d.png","uri@3x": __webpack_public_path__ + "icon-flag.59a2b25a.png",
    width: 29,
    height: 30
});